export default __webpack_public_path__ + "static/media/you-did-it.123c991e.png";